export const eventPage = [
    {
        id: 1,
        status: "Регистрация открыта",
        title: "EVO.INDUSTRY",
        titleUrl: "digitalization-industry",
        year: "2026",
        description: "ВСЕРОССИЙСКИЙ ФОРУМ ЦИФРОВИЗАЦИИ ПРОМЫШЛЕННОСТИ",
        location: "г.Череповец, ДВОРЕЦ МЕТАЛЛУРГОВ, 18-20 ноября",
        date: [
            '18-20',
            'ноября'
        ],
        representatives: "500+",
        reports: "80+",
        space: ">2000м²",
        hall: "2",
        aboutEvent: 1,
        partners: [
            {
                id: 'pao_severstal',
                title: 'ПАО «Северсталь»',
                description: [
                    'ПАО «Северсталь» — вертикально-интегрированная горно-металлургическая компания, создающая новые продукты и комплексные решения из стали вместе с клиентами и партнерами.\n'
                ],
                images: require('../../shared/assets/images/partners/pao_severstal.png'),
                site: 'https://severstal.com/rus/',
                email: 'severstal@severstal.com',
                phone: '+7 (8202) 53 0900',
            },
            {
                id: 'bmc_soft',
                title: 'ООО «БМК-СОФТ»',
                description: [
                    'БМК Софт разрабатывает и внедряет системы цифровизации производственных и бизнес-процессов для промышленных и IT-компаний'
                ],
                images: require('../../shared/assets/images/partners/bmc.png'),
                site: 'https://bmc-soft.ru/',
                email: 'contact@bmksoft.info',
                phone: '+7 (4942) 41-93-11',
            },
            {
                id: 'rus',
                title: 'АРПП «Отечественный софт»',
                description: [
                    'Ассоциация разработчиков программных продуктов «Отечественный софт» — крупнейшее объединение российских производителей тиражируемого программного обеспечения. Ассоциация учреждена в 2009 году ведущими российскими разработчиками. На сегодняшний день  в составе АРПП более 300 компаний.',
                    'Ассоциация является надежной отраслевой площадкой, создает условия для поиска партнеров и взаимодействия с государством, консолидирует игроков рынка для совместной работы над ключевыми вопросами развития ИТ-отрасли.',
                    'АРПП «Отечественный софт» признана наиболее влиятельной ассоциацией в ИТ-отрасли в 2022 году по версии ТAdviser.'
                ],
                images: require('../../shared/assets/images/partners/rus.png'),
                site: 'https://arppsoft.ru/',
                email: 'office@arppsoft.ru',
                phone: '+7 (495) 728-89-59',
            },
            {
                id: 'fuels-digest',
                title: 'FUELS Digest',
                description: [
                    'FUELS Digest - цифровой сервис глобального мониторинга технологической и аналитической документации в области производства и применения нефтяных и альтернативных топлив, присадок, процессов, катализаторов.',
                    'Среди крупнейших подписчиков сервиса НПЗ ПАО «НК «Роснефть», ПАО «АНК «Башнефть», ПАО «НОВАТЭК», ООО «КИНЕФ», АО «ТАИФ-НК», ПАО «Татнефть» имени В.Д. Шашина, ПАО «Газпром», а также компании-производители присадок, научно-исследовательские институты.',
                ],
                images: require('../../shared/assets/images/partners/fuels-digest.jpg'),
                site: 'https://fuelsdigest.com/ ',
            },
            {
                id: 'petrochemicals',
                title: 'Журнал "Нефтепереработка и нефтехимия"',
                description: [
                    'Журнал "Нефтепереработка и нефтехимия" с 1966 года служит важным ресурсом для специалистов нефтеперерабатывающей и нефтехимической отраслей, освещая научные и технологические достижения, актуальные проблемы, а также лучшие практики.',
                    'Журнал включен в официальный список ВАК и проходит строгий процесс рецензирования, что обеспечивает высокое качество и актуальность публикуемых материалов.',
                ],
                images: require('../../shared/assets/images/partners/petrochemicals.jpg'),
                site: 'https://www.npnh.ru/ ',
            },
            {
                id: 'ick',
                title: 'ИЦК Металлургия',
                description: [
                    'Индустриальные центры компетенций (ИЦК) созданы в 2022 году по итогам конференции «Цифровая индустрия промышленной России» по поручению Председателя Правительства РФ Михаила Мишустина. Деятельность ИЦК ориентирована на обеспечение ускоренного замещения зарубежных аналогов российскими отраслевыми цифровыми решениями в отраслях экономики и достижение технологичного суверенитета Российской Федерации.',
                    'Проекты ИЦК направлены на разработку и внедрение российских цифровых продуктов и решений, необходимых для замещения используемых зарубежных продуктов.',
                    'В состав ИЦК входят ведущие индустриальные заказчики и разработчики программного обеспечения. ИЦК «Металлургия» возглавляет «Северсталь».'
                ],
                images: require('../../shared/assets/images/partners/ick.png'),
                site: 'https://ицк-металлургия.рф/ ',
            },
            {
                id: 'expert-network',
                title: 'Экспертная сеть "Северсталь"',
                description: [
                    'Экспертная сеть «Северстали» это совокупность экспертных сообществ, созданных для обмена знаниями, опытом и идеями между специалистами из различных компаний, объединенных общей целью.'
                ],
                images: require('../../shared/assets/images/partners/expert-network.png'),
                site: 'https://innovations.severstal.com/expert-network/',
            },
        ],
        registration: true,
        images: [],
        questions: [
            {
                id: "1",
                question: "Производство & Технологии",
                paragraph: [
                    {
                        id: "1",
                        number: 1,
                        title: "MES и оптимизация переделов:",
                        text: "эффект 1,8 млрд ₽/год на стане 2000;"
                    },
                    {
                        id: "2",
                        number: 2,
                        title: "Оперативное планирование производства (APS):",
                        text: "заказы, станы и энергетика в одной модели;"
                    },
                    {
                        id: "3",
                        number: 3,
                        title: "Цифровые двойники производства:",
                        text: "от моделей к решениям в реальном времени;"
                    },
                    {
                        id: "4",
                        number: 4,
                        title: "Предиктивная диагностика оборудования:",
                        text: "87% точности прогноза отказов;"
                    },
                    {
                        id: "5",
                        number: 5,
                        title: "EAM и ТОиР:",
                        text: "от бумажных ремонтов к цифровому управлению активами;"
                    },
                    {
                        id: "6",
                        number: 6,
                        title: "Энергоучёт и балансы:",
                        text: "АИИС КУЭ как базис энергоэффективности;"
                    },
                    {
                        id: "7",
                        number: 7,
                        title: "Компьютерное зрение и контроль дефектов:",
                        text: "99,2% автоматической разбраковки трубы;"
                    },
                    {
                        id: "8",
                        number: 8,
                        title: "Промышленная робототехника:",
                        text: "российские РТК вместо FANUC и KUKA."
                    },
                ],
            },
            {
                id: "2",
                question: "Данные, ИИ & ИТ-архитектура",
                paragraph: [
                    {
                        id: "1",
                        number: 1,
                        title: "Цифровой суверенитет промышленности:",
                        text: "независимая цифровая экосистема предприятия 2030;"
                    },
                    {
                        id: "2",
                        number: 2,
                        title: "Миграция с зарубежных IIoT-платформ и MES:",
                        text: "перенос истории данных без потерь (ZIIoT вместо OSIsoft PI, GE Predix, Siemens MindSphere);"
                    },
                    {
                        id: "3",
                        number: 3,
                        text: "Кибербезопасность АСУ ТП и защита контуров управления;"
                    },
                    {
                        id: "4",
                        number: 4,
                        title: "«Золотой источник» данных:",
                        text: "единая архитектура MES + Data Lake + LIMS;"
                    },
                    {
                        id: "5",
                        number: 5,
                        text: "Data Lake и Lakehouse в санкционно-устойчивом контуре;"
                    },
                    {
                        id: "6",
                        number: 6,
                        title: "Промышленный MLOps:",
                        text: "перевод 100+ моделей в продуктив и их эксплуатация;"
                    },
                    {
                        id: "7",
                        number: 7,
                        title: "Оцифровка экспертных знаний:",
                        text: "от наставников к базе знаний предприятия;"
                    },
                    {
                        id: "8",
                        number: 8,
                        title: "Коммерциализация цифровых продуктов и экспорт промышленного ПО:",
                        text: "кейсы СНГ и Ближнего Востока."
                    },
                ],
            },
            {
                id: "3",
                question: "Круглые столы",
                paragraph: [
                    {
                        id: "1",
                        number: 1,
                        title: "«Цифровизация логистики и ресурсных активов: ИИ-диспетчер, оптимизация перевозок и обогащения»;",
                    },
                    {
                        id: "2",
                        number: 2,
                        title: "«Оцифровка знаний и культура цифровой трансформации: как сохранить экспертизу и обучить 50 000 сотрудников»;",
                    },
                    {
                        id: "3",
                        number: 3,
                        title: "Закрытый круглый стол CDO/CIO «Промышленный ИИ-2030: стратегические приоритеты лидеров»",
                        text: "- только для первых лиц цифровой трансформации."
                    },
                ],
            },
        ],
        hallLayoutImg: require('../../shared/assets/images/partners/HallLayout11-26.png'),
        program: false,
    },
    {
        id: 2,
        status: "Прошло",
        title: "EVO.INDUSTRY",
        titleUrl: "energy-ecology",
        year: "2025",
        description: "ЦИФРОВИЗАЦИЯ 4.0: ЭНЕРГЕТИКА • ТОиР • ЭКОЛОГИЯ",
        location: "МОСКВА",
        date: [
            '28-29',
            'октября'
        ],
        representatives: "500+",
        reports: "80+",
        space: ">2000м²",
        hall: "2",
        aboutEvent: 2,
        partners: [],
        registration: false,
        images: [
            require('../../shared/assets/images/forum2025/0A7A0067.jpg'),
            require('../../shared/assets/images/forum2025/0A7A0331.jpg'),
            require('../../shared/assets/images/forum2025/0A7A0430.jpg'),
            require('../../shared/assets/images/forum2025/0A7A0463.jpg'),
            require('../../shared/assets/images/forum2025/0A7A0511.jpg'),
            require('../../shared/assets/images/forum2025/0A7A0610.jpg'),
            require('../../shared/assets/images/forum2025/0A7A0729.jpg'),
            require('../../shared/assets/images/forum2025/0A7A0998.jpg'),
            require('../../shared/assets/images/forum2025/0A7A2493.jpg'),
            require('../../shared/assets/images/forum2025/0A7A4509.jpg'),
            require('../../shared/assets/images/forum2025/0A7A9470.jpg'),
            require('../../shared/assets/images/forum2025/0A7A9570.jpg'),
            require('../../shared/assets/images/forum2025/0A7A9902.jpg'),
        ],
        program: false,
    },
    {
        id: 3,
        status: "Прошло",
        title: "EVO.INDUSTRY",
        titleUrl: "toir",
        year: "2026",
        description: "ВСЕРОССИЙСКИЙ ФОРУМ ТОиР",
        location: " «ТОРОВО» (г. Череповец, площадка ПАО «Северсталь»)",
        date: [
            '17-19',
            'апреля'
        ],
        representatives: "500+",
        reports: "80+",
        space: ">2000м²",
        hall: "2",
        aboutEvent: 3,
        partners: [],
        registration: false,
        images: [
            require('../../shared/assets/images/forum042026/1-45.jpg'),
            require('../../shared/assets/images/forum042026/1-101.jpg'),
            require('../../shared/assets/images/forum042026/1-118.jpg'),
            require('../../shared/assets/images/forum042026/1-121.jpg'),
            require('../../shared/assets/images/forum042026/1-156.jpg'),
            require('../../shared/assets/images/forum042026/1-419.jpg'),
            require('../../shared/assets/images/forum042026/1-505.jpg'),
            require('../../shared/assets/images/forum042026/1-533.jpg'),
            require('../../shared/assets/images/forum042026/1-1062.jpg'),
            require('../../shared/assets/images/forum042026/1-1244.jpg'),
            require('../../shared/assets/images/forum042026/1-1361.jpg'),
            require('../../shared/assets/images/forum042026/1-1368.jpg'),
        ],
        program: false,
    },
    {
        id: 4,
        status: "Прошло",
        title: "EVO.INDUSTRY",
        titleUrl: "energy",
        year: "2026",
        description: "ВСЕРОССИЙСКИЙ ФОРУМ ЭНЕРГЕТИКОВ",
        location: " «ТОРОВО» (г. Череповец, площадка ПАО «Северсталь»)",
        date: [
            '17-19',
            'июня'
        ],
        representatives: "500+",
        reports: "80+",
        space: ">2000м²",
        hall: "2",
        aboutEvent: 4,
        partners: [],
        registration: false,
        images: [
            require('../../shared/assets/images/forum062026/1-14.jpg'),
            require('../../shared/assets/images/forum062026/1-15.jpg'),
            require('../../shared/assets/images/forum062026/1-28.jpg'),
            require('../../shared/assets/images/forum062026/1-109.jpg'),
            require('../../shared/assets/images/forum062026/1-130.jpg'),
            require('../../shared/assets/images/forum062026/1-141.jpg'),
            require('../../shared/assets/images/forum062026/1-164.jpg'),
            require('../../shared/assets/images/forum062026/1-165.jpg'),
            require('../../shared/assets/images/forum062026/1-202.jpg'),
            require('../../shared/assets/images/forum062026/1-231.jpg'),
            require('../../shared/assets/images/forum062026/1-234.jpg'),
            require('../../shared/assets/images/forum062026/1-258.jpg'),
            require('../../shared/assets/images/forum062026/1-343.jpg'),
            require('../../shared/assets/images/forum062026/1-532.jpg'),
            require('../../shared/assets/images/forum062026/1-1116.jpg'),
        ],
        program: false,
    },
    {
        id: 5,
        status: "Регистрация скоро",
        title: "EVO.INDUSTRY",
        titleUrl: "transport-logistics",
        year: "2026",
        description: "ВСЕРОССИЙСКИЙ ФОРУМ • ТРАНСПОРТ И ЛОГИСТИКА",
        location: "г.Череповец, БО «ТОРОВО», 9-11 декабря",
        date: [
            '9-11',
            'декабря'
        ],
        reports: "80+",
        days: "2",
        participants: "250",
        participatingEnterprises: "150",
        company: "40",
        excursion: "1",
        aboutEvent: 5,
        partners: [
            {
                id: 'pao_severstal',
                title: 'ПАО «Северсталь»',
                description: [
                    'ПАО «Северсталь» — вертикально-интегрированная горно-металлургическая компания, создающая новые продукты и комплексные решения из стали вместе с клиентами и партнерами.\n'
                ],
                images: require('../../shared/assets/images/partners/pao_severstal.png'),
                site: 'https://severstal.com/rus/',
                email: 'severstal@severstal.com',
                phone: '+7 (8202) 53 0900',
            },
            {
                id: 'bmc_soft',
                title: 'ООО «БМК-СОФТ»',
                description: [
                    'БМК Софт разрабатывает и внедряет системы цифровизации производственных и бизнес-процессов для промышленных и IT-компаний'
                ],
                images: require('../../shared/assets/images/partners/bmc.png'),
                site: 'https://bmc-soft.ru/',
                email: 'contact@bmksoft.info',
                phone: '+7 (4942) 41-93-11',
            },
            {
                id: 'fuels-digest',
                title: 'FUELS Digest',
                description: [
                    'FUELS Digest - цифровой сервис глобального мониторинга технологической и аналитической документации в области производства и применения нефтяных и альтернативных топлив, присадок, процессов, катализаторов.',
                    'Среди крупнейших подписчиков сервиса НПЗ ПАО «НК «Роснефть», ПАО «АНК «Башнефть», ПАО «НОВАТЭК», ООО «КИНЕФ», АО «ТАИФ-НК», ПАО «Татнефть» имени В.Д. Шашина, ПАО «Газпром», а также компании-производители присадок, научно-исследовательские институты.',
                ],
                images: require('../../shared/assets/images/partners/fuels-digest.jpg'),
                site: 'https://fuelsdigest.com/ ',
            },
            {
                id: 'petrochemicals',
                title: 'Журнал "Нефтепереработка и нефтехимия"',
                description: [
                    'Журнал "Нефтепереработка и нефтехимия" с 1966 года служит важным ресурсом для специалистов нефтеперерабатывающей и нефтехимической отраслей, освещая научные и технологические достижения, актуальные проблемы, а также лучшие практики.',
                    'Журнал включен в официальный список ВАК и проходит строгий процесс рецензирования, что обеспечивает высокое качество и актуальность публикуемых материалов.',
                ],
                images: require('../../shared/assets/images/partners/petrochemicals.jpg'),
                site: 'https://www.npnh.ru/ ',
            },
            {
                id: 'ick',
                title: 'ИЦК Металлургия',
                description: [
                    'Индустриальные центры компетенций (ИЦК) созданы в 2022 году по итогам конференции «Цифровая индустрия промышленной России» по поручению Председателя Правительства РФ Михаила Мишустина. Деятельность ИЦК ориентирована на обеспечение ускоренного замещения зарубежных аналогов российскими отраслевыми цифровыми решениями в отраслях экономики и достижение технологичного суверенитета Российской Федерации.',
                    'Проекты ИЦК направлены на разработку и внедрение российских цифровых продуктов и решений, необходимых для замещения используемых зарубежных продуктов.',
                    'В состав ИЦК входят ведущие индустриальные заказчики и разработчики программного обеспечения. ИЦК «Металлургия» возглавляет «Северсталь».'
                ],
                images: require('../../shared/assets/images/partners/ick.png'),
                site: 'https://ицк-металлургия.рф/ ',
            },
            {
                id: 'expert-network',
                title: 'Экспертная сеть "Северсталь"',
                description: [
                    'Экспертная сеть «Северстали» это совокупность экспертных сообществ, созданных для обмена знаниями, опытом и идеями между специалистами из различных компаний, объединенных общей целью.'
                ],
                images: require('../../shared/assets/images/partners/expert-network.png'),
                site: 'https://innovations.severstal.com/expert-network/',
            },
        ],
        registration: true,
        images: [],
        hallLayoutImg: '',
        questions: [
            {
                id: "1",
                question: "Ключевые вопросы",
                paragraph: [
                    {
                        id: "1",
                        number: 1,
                        text: "стратегии цифрового развития транспортно-логистических комплексов промышленных холдингов;"
                    },
                    {
                        id: "2",
                        number: 2,
                        text: "опыт внедрения/перехода на отечественные TMS-, WMS- и ERP-системы;"
                    },
                    {
                        id: "3",
                        number: 3,
                        text: "цифровые платформы грузоперевозок и электронный документооборот (ЭТрН);"
                    },
                    {
                        id: "4",
                        number: 4,
                        text: "технологии ИБ в транспортной инфраструктуре;"
                    },
                    {
                        id: "5",
                        number: 5,
                        text: "беспилотный транспорт и роботизация складского хозяйства;"
                    },
                    {
                        id: "6",
                        number: 6,
                        text: "предиктивное обслуживание подвижного состава и техники (ТОиР);"
                    },
                    {
                        id: "7",
                        number: 7,
                        text: "оптимизация маршрутов, грузопотоков и логистических затрат;"
                    },
                    {
                        id: "8",
                        number: 8,
                        text: "цифровые технологии управления экологией транспорта и пр."
                    },
                ],
            },
        ],
        program: false,
    },
]